export const UPDATE = "questions/UPDATE";
export const APPEND = "questions/APPEND";
export const PREPEND = "questions/PREPEND";
export const UPDATE_ONE = "questions/UPDATE_ONE";
export const DESTROY = "questions/DESTROY";
export const LOADING = "questions/LOADING";
